import { z } from 'zod';
import { baseUserSchema } from './users';

export const shiftStatuses = [
    'Running',
    'Completed',
    'Expired',
    'Excused',
] as const;
export type ShiftStatus = (typeof shiftStatuses)[number];

export const weekdays = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
] as const;

export type Weekday = (typeof weekdays)[number];

export const shiftSchema = z.object({
    id: z.uuidv4(),
    user: baseUserSchema,
    start_at: z.string(),
    end_at: z.string(),
    status: z.enum(shiftStatuses),
    completed_count: z.number().int().nonnegative(),
    target_count: z.number().int().positive(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type Shift = z.infer<typeof shiftSchema>;

export const recurringShiftSchema = z.object({
    id: z.uuidv4(),
    user: baseUserSchema,
    weekday: z.enum(weekdays),
    start_hour: z.number().int().min(0).max(23),
    timezone: z.string().refine(
        (tz) => {
            try {
                // Intl.DateTimeFormat throws an error if the timezone string is invalid
                Intl.DateTimeFormat(undefined, {
                    timeZone: tz ?? undefined,
                });
                return true;
            } catch {
                return false;
            }
        },
        {
            message: 'Invalid IANA timezone identifier',
        },
    ),
    duration: z.number().int().positive().max(168),
    target_count: z.number().int().positive(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type RecurringShift = z.infer<typeof recurringShiftSchema>;
